import { SpeakableSpeechMark } from '../tts.constants';

export function resetSpeechMarks(
  speechMarks: SpeakableSpeechMark[] | undefined
) {
  return (
    speechMarks
      ?.filter(mark => mark.type === 'word')
      .map(s => ({ ...s, played: false })) || []
  );
}
